import { takeLatest, call, put } from 'redux-saga/effects';
import Cookies from 'js-cookie';
import { initFirebase } from 'utils/libraries/firebase';

import { requestOTP, signWithOTP, getLoginInfo } from './api';
import {
  fetchRequestOtpInfoSuccess,
  fetchRequestOtpInfoFail,
  fetchSignWithOtpInfoSuccess,
  fetchSignWithOtpInfoFail,
  fetchLoginInfoSuccess,
  fetchLoginInfoFail,
} from './actions';
import accountManagementActionTypes from './action-types';

function* fetchRequestOtpInfoSaga({ payload }) {
  const { callbackActionSuccess } = payload;

  try {
    const response = yield call(requestOTP, payload);
    yield put(fetchRequestOtpInfoSuccess(response));

    if (callbackActionSuccess) callbackActionSuccess();
  } catch (error) {
    yield put(fetchRequestOtpInfoFail(error));
  }
}

function* fetchSignWithOtpInfoSaga({ payload }) {
  const { callbackActionFail } = payload;

  try {
    const response = yield call(signWithOTP, payload);

    let returnURL = '/bulkOrder';
    if (Cookies.get('hbReturnURL')) returnURL = Cookies.get('hbReturnURL');
    const date = new Date();
    const currentMonth = date.getMonth();
    const expiryDate = date.setMonth(currentMonth + 1);
    Cookies.set('auth', response.data.JWTToken, { expires: new Date(expiryDate) });
    document.location.href = returnURL;

    yield put(fetchSignWithOtpInfoSuccess(response));
  } catch (error) {
    yield put(fetchSignWithOtpInfoFail(error));

    callbackActionFail();
  }
}

function* fetchLoginInfoSaga({ payload }) {
  try {
    const response = yield call(getLoginInfo, payload);
    const firebaseConfigResponse = yield call(initFirebase);

    const userAccessValues = firebaseConfigResponse[process.env.REACT_APP_FIREBASE_AUTH_OBJ_KEY];
    const userAccessValuesArr = userAccessValues?.split(',');

    if (!userAccessValuesArr?.includes(response.data.MobileNumber)) {
      Cookies.remove('auth');
      Cookies.remove('hbReturnURL');
      document.location.href = '/login';
    } else yield put(fetchLoginInfoSuccess(response.data));
  } catch (error) {
    yield put(fetchLoginInfoFail(error));

    Cookies.remove('auth');
    Cookies.remove('hbReturnURL');
    document.location.href = '/login';
  }
}

function* accountManagementSaga() {
  yield takeLatest(accountManagementActionTypes.FETCH_REQUEST_OTP_INFO, fetchRequestOtpInfoSaga);
  yield takeLatest(accountManagementActionTypes.FETCH_SIGN_WITH_OTP_INFO, fetchSignWithOtpInfoSaga);
  yield takeLatest(accountManagementActionTypes.FETCH_LOGIN_INFO, fetchLoginInfoSaga);
}

export default accountManagementSaga;
